import { render, staticRenderFns } from "./swiperBanner.vue?vue&type=template&id=502bffb2&"
import script from "./swiperBanner.vue?vue&type=script&lang=js&"
export * from "./swiperBanner.vue?vue&type=script&lang=js&"
import style0 from "./swiperBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports